import paramFilter from '../admin/param-filter'

export default function jsonToFormData (data) {
  const formData = new FormData()
  if (data) {
    data = paramFilter(data)
    for (let k in data) {
      formData.append(k, data[k])
    }
  }
  return formData
}
